// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.license-lookup-form {
  background: white;
  border-radius: 16px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);
  padding: 40px;
  margin: 32px;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.license-lookup-form:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.12);
}

.license-lookup-form h2 {
  color: #333;
  margin-bottom: 20px;
  text-align: center;
  font-weight: 600;
}

.form-group {
  margin-bottom: 20px;
}

.form-group input {
  width: 100%;
  padding: 16px 20px;
  border: 2px solid #edf2f7;
  border-radius: 12px;
  font-size: 1rem;
  transition: all 0.3s ease;
  background: #f8fafc;
}

.form-group input:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.1);
  background: white;
}

.error-message {
  background-color: rgba(231, 76, 60, 0.15);
  color: #c0392b;
  padding: 12px;
  border-radius: var(--radius-sm);
  margin-bottom: 20px;
  font-size: 0.9rem;
  text-align: center;
}

.staff-table-container .button-group {
  display: flex;
  gap: 12px;
  margin-top: 20px;
}

.staff-table-container .button-group .check-license-btn,
.staff-table-container .button-group .view-full-doc-btn,
.staff-table-container .button-group .view-consent-form-btn {
  padding: 16px 32px;
  border-radius: 12px;
  font-weight: 600;
  font-size: 1rem;
  border: none;
  text-decoration: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.staff-table-container .button-group .check-license-btn {
  background: linear-gradient(135deg, #3b82f6, #2563eb);
  color: white;
  flex: 2 1;
}

.staff-table-container .button-group .view-full-doc-btn,
.staff-table-container .button-group .view-consent-form-btn {
  background: white;
  color: #3b82f6;
  border: 2px solid #3b82f6;
  flex: 1 1;
}

.staff-table-container .button-group .check-license-btn:hover:not(:disabled),
.staff-table-container .button-group .view-full-doc-btn:hover,
.staff-table-container .button-group .view-consent-form-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.staff-table-container .button-group .check-license-btn:disabled {
  background: #e9ecef !important;
  color: #adb5bd !important;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

/* Responsive design */
@media (max-width: 768px) {
  .license-lookup-form {
    margin: 16px 8px;
    padding: 20px;
  }

  .form-group input {
    padding: 12px 16px;
    font-size: 0.9rem;
  }

  .staff-table-container .button-group {
    flex-direction: column;
    gap: 12px;
  }

  .staff-table-container .button-group .check-license-btn,
  .staff-table-container .button-group .view-full-doc-btn,
  .staff-table-container .button-group .view-consent-form-btn {
    width: 100%;
    padding: 12px 20px;
  }

  .view-full-doc-btn {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .details-grid {
    grid-template-columns: 1fr;
  }

  .endorsements-table,
  .categories-table {
    display: block;
    overflow-x: auto;
    white-space: nowrap;
  }

  .endorsements-table th,
  .categories-table th,
  .endorsements-table td,
  .categories-table td {
    padding: 10px;
    font-size: 0.85rem;
  }

  .consent-group label {
    font-size: 0.9rem;
  }
}

@media (max-width: 480px) {
  .license-lookup-form {
    margin: 12px 4px;
    padding: 16px;
  }

  .form-group input {
    padding: 10px 14px;
    font-size: 0.85rem;
  }
}

/* Container for better width control */
.license-details {
  margin-top: 40px;
  animation: slideUpFade 0.5s ease-out;
  background: white;
  border-radius: 16px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
  padding: 30px;
  border: 1px solid rgba(0, 0, 0, 0.05);
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
}

/* Create a flex container for the first two sections */
.info-sections-wrapper {
  display: flex;
  gap: 20px;
  margin-bottom: 30px;
}

/* Base styles for info sections */
.info-section {
  background: #f8fafc;
  border-radius: 12px;
  padding: 20px;
  border: 1px solid #e2e8f0;
  box-shadow: none;
}

/* Driver Information and License Status sections */
.info-sections-wrapper .info-section {
  flex: 1 1;
  min-width: 0; /* Prevents flex items from overflowing */
}

/* Address section and tables take full width */
.info-section:not(.info-sections-wrapper .info-section),
.vehicle-categories,
.endorsements {
  width: 100%;
  margin-bottom: 30px;
}

/* Responsive design */
@media (max-width: 1024px) {
  .info-sections-wrapper {
    flex-direction: column;
    gap: 30px;
  }
}

/* Shared heading styles for all sections */
.info-section h4,
.vehicle-categories h4,
.endorsements h4 {
  color: #1e40af;
  font-size: 1.3rem;
  margin-bottom: 20px;
  padding-bottom: 12px;
  border-bottom: 2px solid rgba(59, 130, 246, 0.2);
}

/* Adjust detail items for better fit */
.detail-item {
  padding: 12px; /* Slightly reduced padding */
  margin-bottom: 8px;
}

.detail-item:hover {
  background: #f8fafc;
}

.detail-item strong {
  color: #64748b;
  font-size: 0.85rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  display: block;
  margin-bottom: 5px;
}

/* Status Badges */
.status {
  display: inline-flex;
  align-items: center;
  padding: 6px 12px;
  border-radius: 20px;
  font-weight: 600;
  font-size: 0.9rem;
}

.status.valid {
  background: #dcfce7;
  color: #166534;
}

.status.invalid,
.status.disqualified {
  background: #fee2e2;
  color: #991b1b;
}

.status.expired {
  background: #fff1f2;
  color: #9f1239;
}

/* Points Display */
.points {
  display: inline-flex;
  align-items: center;
  padding: 6px 12px;
  border-radius: 20px;
  font-weight: 600;
  font-size: 0.9rem;
}

.points.low {
  background: #dcfce7;
  color: #166534;
}

.points.medium {
  background: #fef9c3;
  color: #854d0e;
}

.points.high {
  background: #fee2e2;
  color: #991b1b;
}

/* Vehicle Categories and Endorsements Styling */
.vehicle-categories,
.endorsements {
  background: #f8fafc;
  padding: 24px;
  border-radius: 12px;
  margin: 24px 0;
  border: 1px solid #e2e8f0;
  box-shadow: none;
  width: 100%;
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
}

.vehicle-categories table,
.endorsements table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  background: white;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #e2e8f0;
}

.vehicle-categories th,
.endorsements th {
  background: #f1f5f9;
  color: #1e293b;
  font-weight: 600;
  text-align: left;
  padding: 16px;
  border-bottom: 2px solid #e2e8f0;
}

.vehicle-categories td,
.endorsements td {
  padding: 14px 16px;
  border-bottom: 1px solid #e2e8f0;
  color: #475569;
}

.vehicle-categories tr:last-child td,
.endorsements tr:last-child td {
  border-bottom: none;
}

.vehicle-categories tr:hover td,
.endorsements tr:hover td {
  background-color: #f8fafc;
}

/* Endorsements specific styles */
.endorsements td:nth-child(2) { /* Points column */
  font-weight: 600;
  color: #ef4444;
}

.endorsements td:nth-child(5) { /* Description column */
  font-size: 0.95rem;
  line-height: 1.5;
  max-width: 400px;
}

/* Vehicle Categories specific styles */
.vehicle-categories td:nth-child(1) { /* Category column */
  font-weight: 600;
  color: #1e40af;
}

.vehicle-categories td:nth-child(2) { /* Type column */
  text-transform: capitalize;
}

/* Responsive table styles */
@media (max-width: 1024px) {
  .vehicle-categories,
  .endorsements {
    padding: 16px;
    margin: 16px 0;
  }

  .vehicle-categories table,
  .endorsements table {
    display: block;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  .vehicle-categories td,
  .endorsements td {
    white-space: nowrap;
  }

  .vehicle-categories td:last-child,
  .endorsements td:last-child {
    white-space: normal;
  }
}

/* Complete Button Enhancement */
.complete-section {
  margin-top: 30px;
  text-align: center;
}

.complete-btn {
  background: linear-gradient(135deg, #3b82f6, #2563eb);
  color: white;
  padding: 15px 40px;
  border-radius: 30px;
  font-weight: 600;
  font-size: 1rem;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 6px rgba(37, 99, 235, 0.2);
}

.complete-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 12px rgba(37, 99, 235, 0.3);
}

.complete-btn.success {
  background: linear-gradient(135deg, #22c55e, #16a34a);
  box-shadow: 0 4px 6px rgba(22, 163, 74, 0.2);
}

/* Animation */
@keyframes slideUpFade {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.endorsements, 
.categories {
  background: white;
  padding: 24px;
  border-radius: var(--radius-md);
  margin: 24px 0;
  box-shadow: var(--shadow-sm);
}

.endorsements ul,
.categories ul {
  list-style: none;
  padding: 0;
}

.endorsements li,
.categories li {
  padding: 12px;
  border-bottom: 1px solid var(--border-color);
  font-size: 0.9rem;
}

.endorsements li:last-child,
.categories li:last-child {
  border-bottom: none;
}

.consent-group {
  margin: 15px 0;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 12px;
}

.consent-group label {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  flex: 0 1 auto;
}

/* Animations */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Enhanced table styling */
.endorsements-table,
.categories-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  margin: 24px 0;
  border-radius: var(--radius-md);
  overflow: hidden;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
}

.endorsements-table th,
.categories-table th {
  background: var(--background-light);
  padding: 16px;
  font-weight: 600;
  color: var(--text-primary);
  text-align: left;
}

.endorsements-table td,
.categories-table td {
  padding: 14px 16px;
  border-top: 1px solid var(--border-color);
  transition: background-color 0.2s ease;
}

.endorsements-table tr:hover td,
.categories-table tr:hover td {
  background-color: var(--background-light);
}

.restrictions {
  margin-top: 20px;
}

.restrictions-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
}

.restrictions-table th,
.restrictions-table td {
  padding: 8px;
  text-align: left;
  border: 1px solid #ddd;
}

.restrictions-table th {
  background-color: #f5f5f5;
}

.restriction-list {
  margin: 0;
  padding-left: 20px;
  list-style-type: disc;
}

.restriction-list li {
  margin: 2px 0;
}

.csv-progress {
  margin: 20px 0;
  padding: 15px;
  background: #f8f9fa;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.progress-bar {
  height: 10px;
  background: #e9ecef;
  border-radius: 5px;
  margin: 10px 0;
  overflow: hidden;
}

.progress-fill {
  height: 100%;
  background: #007bff;
  transition: width 0.3s ease;
}

.progress-text {
  font-size: 14px;
  color: #6c757d;
  margin-bottom: 10px;
}

.csv-errors {
  margin-top: 15px;
  padding: 10px;
  background: #fff3cd;
  border-radius: 4px;
}

.error-list {
  max-height: 200px;
  overflow-y: auto;
}

.error-item {
  display: flex;
  align-items: center;
  padding: 8px;
  margin: 4px 0;
  background: rgba(255, 255, 255, 0.5);
  border-radius: 4px;
}

.error-icon {
  margin-right: 8px;
}

.error-text {
  font-size: 14px;
  color: #856404;
}

.notification {
  position: fixed;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  padding: 15px 25px;
  border-radius: 8px;
  animation: slideInDown 0.3s ease;
  z-index: 1000;
  min-width: 300px;
  text-align: center;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
}

.notification.success {
  background: #d4edda;
  color: #155724;
  border: 1px solid #c3e6cb;
}

.notification.warning {
  background: #fff3cd;
  color: #856404;
  border: 1px solid #ffeeba;
}

.notification.error {
  background: #f8d7da;
  color: #721c24;
  border: 1px solid #f5c6cb;
}

@keyframes slideInDown {
  from {
    transform: translate(-50%, -100%);
    opacity: 0;
  }
  to {
    transform: translate(-50%, 0);
    opacity: 1;
  }
}

.notification-content {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.notification .icon {
  font-size: 1.2em;
}

/* Progress bar */
.notification::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 3px;
  background: rgba(255, 255, 255, 0.5);
  animation: shrinkBar 3s linear forwards;
}

@keyframes shrinkBar {
  from {
    width: 100%;
  }
  to {
    width: 0%;
  }
}

/* Add fade out animation */
.notification.hide {
  animation: fadeOut 0.3s ease forwards;
}

@keyframes fadeOut {
  from {
    opacity: 1;
    transform: translate(-50%, 0);
  }
  to {
    opacity: 0;
    transform: translate(-50%, -20px);
  }
}

/* Updated Form Styling */
.license-lookup-container {
  max-width: 1500px;
  margin: 0 auto;
  padding: 20px;
}

.lookup-methods {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  margin-bottom: 30px;
}

.lookup-method {
  background: white;
  border-radius: 12px;
  padding: 24px;
  border: 2px solid #edf2f7;
  transition: all 0.3s ease;
  cursor: pointer;
}

.lookup-method:hover {
  border-color: #3b82f6;
  transform: translateY(-2px);
}

.lookup-method.active {
  border-color: #3b82f6;
  background: #f0f7ff;
}

.lookup-method h3 {
  color: #2d3748;
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.lookup-method p {
  color: #718096;
  font-size: 0.9rem;
  margin-bottom: 16px;
}

.lookup-content {
  margin-top: 20px;
  background: white;
  border-radius: 12px;
  padding: 24px;
  border: 2px solid #edf2f7;
}

.file-upload-area {
  border: 2px dashed #cbd5e0;
  border-radius: 12px;
  padding: 30px;
  text-align: center;
  transition: all 0.3s ease;
  cursor: pointer;
}

.file-upload-area:hover {
  border-color: #3b82f6;
  background: #f0f7ff;
}

.file-upload-area .icon {
  font-size: 24px;
  margin-bottom: 12px;
  color: #3b82f6;
}

/* Disabled state for file upload area */
.file-upload-area label.disabled {
  opacity: 0.6;
  cursor: not-allowed;
  background: #f5f5f5;
  border-color: #e2e8f0;
}

.file-upload-area label.disabled:hover {
  border-color: #e2e8f0;
  background: #f5f5f5;
  transform: none;
}

.file-upload-area label.disabled .icon {
  color: #a0aec0;
}

/* Updated Progress Bar */
.progress-container {
  margin-top: 20px;
  opacity: 1;
  transition: opacity 0.3s ease;
}

.progress-container.hide {
  opacity: 0;
}

.progress-bar {
  height: 6px;
  background: #e2e8f0;
  border-radius: 3px;
  overflow: hidden;
  margin: 10px 0;
}

.progress-fill {
  height: 100%;
  background: linear-gradient(90deg, #3b82f6, #2563eb);
  transition: width 0.3s ease;
}

.view-consent-doc {
  padding: 16px 32px;
  border-radius: 12px;
  background: white;
  color: #1e3a8a;
  border: 2px solid #3b82f6;
  font-weight: 600;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  margin-top: 0;
  flex-shrink: 0;
}

.view-consent-doc:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  background: #f8fafc;
  color: #1e40af;
}`, "",{"version":3,"sources":["webpack://./src/components/AddStaffForm.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,0CAA0C;EAC1C,aAAa;EACb,YAAY;EACZ,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;EAC7C,iBAAiB;AACnB;;AAEA;EACE,yCAAyC;EACzC,cAAc;EACd,aAAa;EACb,+BAA+B;EAC/B,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;;;EAGE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;EACE,qDAAqD;EACrD,YAAY;EACZ,SAAO;AACT;;AAEA;;EAEE,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,SAAO;AACT;;AAEA;;;EAGE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE;IACE,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;;;IAGE,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;IAEE,cAAc;IACd,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;;;;IAIE,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;EACpB;AACF;;AAEA,uCAAuC;AACvC;EACE,gBAAgB;EAChB,oCAAoC;EACpC,iBAAiB;EACjB,mBAAmB;EACnB,2CAA2C;EAC3C,aAAa;EACb,qCAAqC;EACrC,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,uDAAuD;AACvD;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA,kCAAkC;AAClC;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA,mDAAmD;AACnD;EACE,SAAO;EACP,YAAY,EAAE,yCAAyC;AACzD;;AAEA,+CAA+C;AAC/C;;;EAGE,WAAW;EACX,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE;IACE,sBAAsB;IACtB,SAAS;EACX;AACF;;AAEA,2CAA2C;AAC3C;;;EAGE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;EACpB,gDAAgD;AAClD;;AAEA,uCAAuC;AACvC;EACE,aAAa,EAAE,6BAA6B;EAC5C,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,kBAAkB;AACpB;;AAEA,kBAAkB;AAClB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,gDAAgD;AAChD;;EAEE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,gCAAgC;AAClC;;AAEA;;EAEE,kBAAkB;EAClB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA,iCAAiC;AACjC,gCAAgC,kBAAkB;EAChD,gBAAgB;EAChB,cAAc;AAChB;;AAEA,gCAAgC,uBAAuB;EACrD,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,uCAAuC;AACvC,sCAAsC,oBAAoB;EACxD,gBAAgB;EAChB,cAAc;AAChB;;AAEA,sCAAsC,gBAAgB;EACpD,0BAA0B;AAC5B;;AAEA,4BAA4B;AAC5B;EACE;;IAEE,aAAa;IACb,cAAc;EAChB;;EAEA;;IAEE,cAAc;IACd,gBAAgB;IAChB,iCAAiC;EACnC;;EAEA;;IAEE,mBAAmB;EACrB;;EAEA;;IAEE,mBAAmB;EACrB;AACF;;AAEA,gCAAgC;AAChC;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,qDAAqD;EACrD,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,4CAA4C;AAC9C;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,qDAAqD;EACrD,4CAA4C;AAC9C;;AAEA,cAAc;AACd;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;;EAEE,iBAAiB;EACjB,aAAa;EACb,+BAA+B;EAC/B,cAAc;EACd,4BAA4B;AAC9B;;AAEA;;EAEE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;;EAEE,aAAa;EACb,4CAA4C;EAC5C,iBAAiB;AACnB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;AAChB;;AAEA,eAAe;AACf;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,2BAA2B;AAC3B;;EAEE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,cAAc;EACd,+BAA+B;EAC/B,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;;EAEE,mCAAmC;EACnC,aAAa;EACb,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,yCAAyC;EACzC,sCAAsC;AACxC;;AAEA;;EAEE,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;;EAEE,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,kBAAkB;EAClB,kBAAkB;EAClB,gCAAgC;EAChC,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE;IACE,iCAAiC;IACjC,UAAU;EACZ;EACA;IACE,6BAA6B;IAC7B,UAAU;EACZ;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,WAAW;EACX,oCAAoC;EACpC,uCAAuC;AACzC;;AAEA;EACE;IACE,WAAW;EACb;EACA;IACE,SAAS;EACX;AACF;;AAEA,2BAA2B;AAC3B;EACE,qCAAqC;AACvC;;AAEA;EACE;IACE,UAAU;IACV,6BAA6B;EAC/B;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA,yBAAyB;AACzB;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;;AAEA,wCAAwC;AACxC;EACE,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA,yBAAyB;AACzB;EACE,gBAAgB;EAChB,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,oDAAoD;EACpD,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,wCAAwC;EACxC,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;EAC1C,mBAAmB;EACnB,cAAc;AAChB","sourcesContent":[".license-lookup-form {\n  background: white;\n  border-radius: 16px;\n  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);\n  padding: 40px;\n  margin: 32px;\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n}\n\n.license-lookup-form:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.12);\n}\n\n.license-lookup-form h2 {\n  color: #333;\n  margin-bottom: 20px;\n  text-align: center;\n  font-weight: 600;\n}\n\n.form-group {\n  margin-bottom: 20px;\n}\n\n.form-group input {\n  width: 100%;\n  padding: 16px 20px;\n  border: 2px solid #edf2f7;\n  border-radius: 12px;\n  font-size: 1rem;\n  transition: all 0.3s ease;\n  background: #f8fafc;\n}\n\n.form-group input:focus {\n  outline: none;\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.1);\n  background: white;\n}\n\n.error-message {\n  background-color: rgba(231, 76, 60, 0.15);\n  color: #c0392b;\n  padding: 12px;\n  border-radius: var(--radius-sm);\n  margin-bottom: 20px;\n  font-size: 0.9rem;\n  text-align: center;\n}\n\n.staff-table-container .button-group {\n  display: flex;\n  gap: 12px;\n  margin-top: 20px;\n}\n\n.staff-table-container .button-group .check-license-btn,\n.staff-table-container .button-group .view-full-doc-btn,\n.staff-table-container .button-group .view-consent-form-btn {\n  padding: 16px 32px;\n  border-radius: 12px;\n  font-weight: 600;\n  font-size: 1rem;\n  border: none;\n  text-decoration: none;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.staff-table-container .button-group .check-license-btn {\n  background: linear-gradient(135deg, #3b82f6, #2563eb);\n  color: white;\n  flex: 2;\n}\n\n.staff-table-container .button-group .view-full-doc-btn,\n.staff-table-container .button-group .view-consent-form-btn {\n  background: white;\n  color: #3b82f6;\n  border: 2px solid #3b82f6;\n  flex: 1;\n}\n\n.staff-table-container .button-group .check-license-btn:hover:not(:disabled),\n.staff-table-container .button-group .view-full-doc-btn:hover,\n.staff-table-container .button-group .view-consent-form-btn:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n}\n\n.staff-table-container .button-group .check-license-btn:disabled {\n  background: #e9ecef !important;\n  color: #adb5bd !important;\n  cursor: not-allowed;\n  transform: none;\n  box-shadow: none;\n}\n\n/* Responsive design */\n@media (max-width: 768px) {\n  .license-lookup-form {\n    margin: 16px 8px;\n    padding: 20px;\n  }\n\n  .form-group input {\n    padding: 12px 16px;\n    font-size: 0.9rem;\n  }\n\n  .staff-table-container .button-group {\n    flex-direction: column;\n    gap: 12px;\n  }\n\n  .staff-table-container .button-group .check-license-btn,\n  .staff-table-container .button-group .view-full-doc-btn,\n  .staff-table-container .button-group .view-consent-form-btn {\n    width: 100%;\n    padding: 12px 20px;\n  }\n\n  .view-full-doc-btn {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n  .details-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .endorsements-table,\n  .categories-table {\n    display: block;\n    overflow-x: auto;\n    white-space: nowrap;\n  }\n\n  .endorsements-table th,\n  .categories-table th,\n  .endorsements-table td,\n  .categories-table td {\n    padding: 10px;\n    font-size: 0.85rem;\n  }\n\n  .consent-group label {\n    font-size: 0.9rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .license-lookup-form {\n    margin: 12px 4px;\n    padding: 16px;\n  }\n\n  .form-group input {\n    padding: 10px 14px;\n    font-size: 0.85rem;\n  }\n}\n\n/* Container for better width control */\n.license-details {\n  margin-top: 40px;\n  animation: slideUpFade 0.5s ease-out;\n  background: white;\n  border-radius: 16px;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);\n  padding: 30px;\n  border: 1px solid rgba(0, 0, 0, 0.05);\n  max-width: 1200px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n/* Create a flex container for the first two sections */\n.info-sections-wrapper {\n  display: flex;\n  gap: 20px;\n  margin-bottom: 30px;\n}\n\n/* Base styles for info sections */\n.info-section {\n  background: #f8fafc;\n  border-radius: 12px;\n  padding: 20px;\n  border: 1px solid #e2e8f0;\n  box-shadow: none;\n}\n\n/* Driver Information and License Status sections */\n.info-sections-wrapper .info-section {\n  flex: 1;\n  min-width: 0; /* Prevents flex items from overflowing */\n}\n\n/* Address section and tables take full width */\n.info-section:not(.info-sections-wrapper .info-section),\n.vehicle-categories,\n.endorsements {\n  width: 100%;\n  margin-bottom: 30px;\n}\n\n/* Responsive design */\n@media (max-width: 1024px) {\n  .info-sections-wrapper {\n    flex-direction: column;\n    gap: 30px;\n  }\n}\n\n/* Shared heading styles for all sections */\n.info-section h4,\n.vehicle-categories h4,\n.endorsements h4 {\n  color: #1e40af;\n  font-size: 1.3rem;\n  margin-bottom: 20px;\n  padding-bottom: 12px;\n  border-bottom: 2px solid rgba(59, 130, 246, 0.2);\n}\n\n/* Adjust detail items for better fit */\n.detail-item {\n  padding: 12px; /* Slightly reduced padding */\n  margin-bottom: 8px;\n}\n\n.detail-item:hover {\n  background: #f8fafc;\n}\n\n.detail-item strong {\n  color: #64748b;\n  font-size: 0.85rem;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  display: block;\n  margin-bottom: 5px;\n}\n\n/* Status Badges */\n.status {\n  display: inline-flex;\n  align-items: center;\n  padding: 6px 12px;\n  border-radius: 20px;\n  font-weight: 600;\n  font-size: 0.9rem;\n}\n\n.status.valid {\n  background: #dcfce7;\n  color: #166534;\n}\n\n.status.invalid,\n.status.disqualified {\n  background: #fee2e2;\n  color: #991b1b;\n}\n\n.status.expired {\n  background: #fff1f2;\n  color: #9f1239;\n}\n\n/* Points Display */\n.points {\n  display: inline-flex;\n  align-items: center;\n  padding: 6px 12px;\n  border-radius: 20px;\n  font-weight: 600;\n  font-size: 0.9rem;\n}\n\n.points.low {\n  background: #dcfce7;\n  color: #166534;\n}\n\n.points.medium {\n  background: #fef9c3;\n  color: #854d0e;\n}\n\n.points.high {\n  background: #fee2e2;\n  color: #991b1b;\n}\n\n/* Vehicle Categories and Endorsements Styling */\n.vehicle-categories,\n.endorsements {\n  background: #f8fafc;\n  padding: 24px;\n  border-radius: 12px;\n  margin: 24px 0;\n  border: 1px solid #e2e8f0;\n  box-shadow: none;\n  width: 100%;\n  max-width: 1200px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.vehicle-categories table,\n.endorsements table {\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n  background: white;\n  border-radius: 8px;\n  overflow: hidden;\n  border: 1px solid #e2e8f0;\n}\n\n.vehicle-categories th,\n.endorsements th {\n  background: #f1f5f9;\n  color: #1e293b;\n  font-weight: 600;\n  text-align: left;\n  padding: 16px;\n  border-bottom: 2px solid #e2e8f0;\n}\n\n.vehicle-categories td,\n.endorsements td {\n  padding: 14px 16px;\n  border-bottom: 1px solid #e2e8f0;\n  color: #475569;\n}\n\n.vehicle-categories tr:last-child td,\n.endorsements tr:last-child td {\n  border-bottom: none;\n}\n\n.vehicle-categories tr:hover td,\n.endorsements tr:hover td {\n  background-color: #f8fafc;\n}\n\n/* Endorsements specific styles */\n.endorsements td:nth-child(2) { /* Points column */\n  font-weight: 600;\n  color: #ef4444;\n}\n\n.endorsements td:nth-child(5) { /* Description column */\n  font-size: 0.95rem;\n  line-height: 1.5;\n  max-width: 400px;\n}\n\n/* Vehicle Categories specific styles */\n.vehicle-categories td:nth-child(1) { /* Category column */\n  font-weight: 600;\n  color: #1e40af;\n}\n\n.vehicle-categories td:nth-child(2) { /* Type column */\n  text-transform: capitalize;\n}\n\n/* Responsive table styles */\n@media (max-width: 1024px) {\n  .vehicle-categories,\n  .endorsements {\n    padding: 16px;\n    margin: 16px 0;\n  }\n\n  .vehicle-categories table,\n  .endorsements table {\n    display: block;\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  .vehicle-categories td,\n  .endorsements td {\n    white-space: nowrap;\n  }\n\n  .vehicle-categories td:last-child,\n  .endorsements td:last-child {\n    white-space: normal;\n  }\n}\n\n/* Complete Button Enhancement */\n.complete-section {\n  margin-top: 30px;\n  text-align: center;\n}\n\n.complete-btn {\n  background: linear-gradient(135deg, #3b82f6, #2563eb);\n  color: white;\n  padding: 15px 40px;\n  border-radius: 30px;\n  font-weight: 600;\n  font-size: 1rem;\n  border: none;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 6px rgba(37, 99, 235, 0.2);\n}\n\n.complete-btn:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 12px rgba(37, 99, 235, 0.3);\n}\n\n.complete-btn.success {\n  background: linear-gradient(135deg, #22c55e, #16a34a);\n  box-shadow: 0 4px 6px rgba(22, 163, 74, 0.2);\n}\n\n/* Animation */\n@keyframes slideUpFade {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.endorsements, \n.categories {\n  background: white;\n  padding: 24px;\n  border-radius: var(--radius-md);\n  margin: 24px 0;\n  box-shadow: var(--shadow-sm);\n}\n\n.endorsements ul,\n.categories ul {\n  list-style: none;\n  padding: 0;\n}\n\n.endorsements li,\n.categories li {\n  padding: 12px;\n  border-bottom: 1px solid var(--border-color);\n  font-size: 0.9rem;\n}\n\n.endorsements li:last-child,\n.categories li:last-child {\n  border-bottom: none;\n}\n\n.consent-group {\n  margin: 15px 0;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 12px;\n}\n\n.consent-group label {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n  flex: 0 1 auto;\n}\n\n/* Animations */\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Enhanced table styling */\n.endorsements-table,\n.categories-table {\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n  margin: 24px 0;\n  border-radius: var(--radius-md);\n  overflow: hidden;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);\n}\n\n.endorsements-table th,\n.categories-table th {\n  background: var(--background-light);\n  padding: 16px;\n  font-weight: 600;\n  color: var(--text-primary);\n  text-align: left;\n}\n\n.endorsements-table td,\n.categories-table td {\n  padding: 14px 16px;\n  border-top: 1px solid var(--border-color);\n  transition: background-color 0.2s ease;\n}\n\n.endorsements-table tr:hover td,\n.categories-table tr:hover td {\n  background-color: var(--background-light);\n}\n\n.restrictions {\n  margin-top: 20px;\n}\n\n.restrictions-table {\n  width: 100%;\n  border-collapse: collapse;\n  margin-top: 10px;\n}\n\n.restrictions-table th,\n.restrictions-table td {\n  padding: 8px;\n  text-align: left;\n  border: 1px solid #ddd;\n}\n\n.restrictions-table th {\n  background-color: #f5f5f5;\n}\n\n.restriction-list {\n  margin: 0;\n  padding-left: 20px;\n  list-style-type: disc;\n}\n\n.restriction-list li {\n  margin: 2px 0;\n}\n\n.csv-progress {\n  margin: 20px 0;\n  padding: 15px;\n  background: #f8f9fa;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n}\n\n.progress-bar {\n  height: 10px;\n  background: #e9ecef;\n  border-radius: 5px;\n  margin: 10px 0;\n  overflow: hidden;\n}\n\n.progress-fill {\n  height: 100%;\n  background: #007bff;\n  transition: width 0.3s ease;\n}\n\n.progress-text {\n  font-size: 14px;\n  color: #6c757d;\n  margin-bottom: 10px;\n}\n\n.csv-errors {\n  margin-top: 15px;\n  padding: 10px;\n  background: #fff3cd;\n  border-radius: 4px;\n}\n\n.error-list {\n  max-height: 200px;\n  overflow-y: auto;\n}\n\n.error-item {\n  display: flex;\n  align-items: center;\n  padding: 8px;\n  margin: 4px 0;\n  background: rgba(255, 255, 255, 0.5);\n  border-radius: 4px;\n}\n\n.error-icon {\n  margin-right: 8px;\n}\n\n.error-text {\n  font-size: 14px;\n  color: #856404;\n}\n\n.notification {\n  position: fixed;\n  top: 20px;\n  left: 50%;\n  transform: translateX(-50%);\n  padding: 15px 25px;\n  border-radius: 8px;\n  animation: slideInDown 0.3s ease;\n  z-index: 1000;\n  min-width: 300px;\n  text-align: center;\n  height: 56px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-sizing: border-box;\n}\n\n.notification.success {\n  background: #d4edda;\n  color: #155724;\n  border: 1px solid #c3e6cb;\n}\n\n.notification.warning {\n  background: #fff3cd;\n  color: #856404;\n  border: 1px solid #ffeeba;\n}\n\n.notification.error {\n  background: #f8d7da;\n  color: #721c24;\n  border: 1px solid #f5c6cb;\n}\n\n@keyframes slideInDown {\n  from {\n    transform: translate(-50%, -100%);\n    opacity: 0;\n  }\n  to {\n    transform: translate(-50%, 0);\n    opacity: 1;\n  }\n}\n\n.notification-content {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  font-weight: 500;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.notification .icon {\n  font-size: 1.2em;\n}\n\n/* Progress bar */\n.notification::after {\n  content: '';\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 3px;\n  background: rgba(255, 255, 255, 0.5);\n  animation: shrinkBar 3s linear forwards;\n}\n\n@keyframes shrinkBar {\n  from {\n    width: 100%;\n  }\n  to {\n    width: 0%;\n  }\n}\n\n/* Add fade out animation */\n.notification.hide {\n  animation: fadeOut 0.3s ease forwards;\n}\n\n@keyframes fadeOut {\n  from {\n    opacity: 1;\n    transform: translate(-50%, 0);\n  }\n  to {\n    opacity: 0;\n    transform: translate(-50%, -20px);\n  }\n}\n\n/* Updated Form Styling */\n.license-lookup-container {\n  max-width: 1500px;\n  margin: 0 auto;\n  padding: 20px;\n}\n\n.lookup-methods {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 20px;\n  margin-bottom: 30px;\n}\n\n.lookup-method {\n  background: white;\n  border-radius: 12px;\n  padding: 24px;\n  border: 2px solid #edf2f7;\n  transition: all 0.3s ease;\n  cursor: pointer;\n}\n\n.lookup-method:hover {\n  border-color: #3b82f6;\n  transform: translateY(-2px);\n}\n\n.lookup-method.active {\n  border-color: #3b82f6;\n  background: #f0f7ff;\n}\n\n.lookup-method h3 {\n  color: #2d3748;\n  margin-bottom: 12px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.lookup-method p {\n  color: #718096;\n  font-size: 0.9rem;\n  margin-bottom: 16px;\n}\n\n.lookup-content {\n  margin-top: 20px;\n  background: white;\n  border-radius: 12px;\n  padding: 24px;\n  border: 2px solid #edf2f7;\n}\n\n.file-upload-area {\n  border: 2px dashed #cbd5e0;\n  border-radius: 12px;\n  padding: 30px;\n  text-align: center;\n  transition: all 0.3s ease;\n  cursor: pointer;\n}\n\n.file-upload-area:hover {\n  border-color: #3b82f6;\n  background: #f0f7ff;\n}\n\n.file-upload-area .icon {\n  font-size: 24px;\n  margin-bottom: 12px;\n  color: #3b82f6;\n}\n\n/* Disabled state for file upload area */\n.file-upload-area label.disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  background: #f5f5f5;\n  border-color: #e2e8f0;\n}\n\n.file-upload-area label.disabled:hover {\n  border-color: #e2e8f0;\n  background: #f5f5f5;\n  transform: none;\n}\n\n.file-upload-area label.disabled .icon {\n  color: #a0aec0;\n}\n\n/* Updated Progress Bar */\n.progress-container {\n  margin-top: 20px;\n  opacity: 1;\n  transition: opacity 0.3s ease;\n}\n\n.progress-container.hide {\n  opacity: 0;\n}\n\n.progress-bar {\n  height: 6px;\n  background: #e2e8f0;\n  border-radius: 3px;\n  overflow: hidden;\n  margin: 10px 0;\n}\n\n.progress-fill {\n  height: 100%;\n  background: linear-gradient(90deg, #3b82f6, #2563eb);\n  transition: width 0.3s ease;\n}\n\n.view-consent-doc {\n  padding: 16px 32px;\n  border-radius: 12px;\n  background: white;\n  color: #1e3a8a;\n  border: 2px solid #3b82f6;\n  font-weight: 600;\n  font-size: 1rem;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  margin-top: 0;\n  flex-shrink: 0;\n}\n\n.view-consent-doc:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  background: #f8fafc;\n  color: #1e40af;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
